/**
 * POST a round-completion event to the v0.1 capture endpoint. Fire-and-forget.
 */

const COMPLETE_ENDPOINT = import.meta.env.VITE_COMPLETE_ENDPOINT ?? '';

export interface CompletionEvent {
  deviceId: string;
  displayName: string;
  dayId: string;
  score: number;
  completedAt: string;
  isFirstAttempt: boolean;
}

export function postCompletion(ev: CompletionEvent): void {
  if (!COMPLETE_ENDPOINT) {
    console.info('[completion]', ev);
    return;
  }
  // Use sendBeacon when available so the request survives end-of-round
  // navigation; fall back to fetch.
  try {
    const body = JSON.stringify(ev);
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(COMPLETE_ENDPOINT, blob);
      return;
    }
    void fetch(COMPLETE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    });
  } catch (err) {
    console.warn('[completion] failed to post', err);
  }
}
